/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Further_Boiler_Room_HeadlineInputs */



/**
* | output |
* | --- |
* | "Control your boiler room remotely" |
*
* @param {Go_Further_Boiler_Room_HeadlineInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_boiler_room_headline = /** @type {((inputs?: Go_Further_Boiler_Room_HeadlineInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Boiler_Room_HeadlineInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Control your boiler room remotely")
	return /** @type {LocalizedString} */ ("Pilotez votre chaufferie à distance")
});